import { render, staticRenderFns } from "./CategoryAddPage.vue?vue&type=template&id=02bbabce&scoped=true&"
import script from "./CategoryAddPage.vue?vue&type=script&lang=js&"
export * from "./CategoryAddPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAddPage.vue?vue&type=style&index=0&id=02bbabce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bbabce",
  null
  
)

export default component.exports